import { useQuery } from "react-query";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { fetchQuestionnaires } from "../hooks/useQuestionnaires";
import { getFinalNumberFromPath, getLastPathByRegex } from "../utilities/UIHelper";
import { Questionnaire } from "../models/types";

const QUESTIONNAIRE_NAVIGATOR_KEY = "questionnaire-navigator";

export const useQuestionnairePathState = (
  locationState: any,
  path: string,
  redirect: boolean = true
) => {
  const questionnaireId = locationState?.questionnaireId;
  const edit = locationState?.edit;
  const lastPath = getLastPathByRegex(path);
  const number = getFinalNumberFromPath(lastPath);
  const navigate = useNavigate();
  return useQuery<{
    questionnaireId: string;
    edit: boolean;
  }>(
    [QUESTIONNAIRE_NAVIGATOR_KEY, path],
    async () => {
      if (questionnaireId != null) {
        return { questionnaireId, edit };
      }
      const questionnaires = await fetchQuestionnaires({ questionnaire_num: [number] });
      const questionnaire = questionnaires.results.find(
        (t) => t.questionnaire_num === Number(number)
      );
      if (!questionnaire && redirect) {
        navigate("/oversight/questionnaires");
        return { questionnaireId: null, edit };
      }

      return { questionnaireId: questionnaire?.id, edit };
    },
    { suspense: true }
  );
};

const navigateToQuestionnaire = (params: {
  navigate: NavigateFunction;
  questionnaireId: string;
  questionnaireNumber: number;
  edit?: boolean;
}) => {
  const { questionnaireId, questionnaireNumber, edit, navigate } = params;
  navigate(`/oversight/questionnaires/questionnaire-${questionnaireNumber}`, {
    state: {
      questionnaireId,
      questionnaireNumber,
      edit,
    },
  });
};

const navigateToQuestionnaireInNewTab = (questionnaire: Questionnaire) => {
  window.open(
    `/oversight/questionnaires/questionnaire-${questionnaire.questionnaire_num}`,
    "_blank"
  );
};

export { navigateToQuestionnaire, navigateToQuestionnaireInNewTab };
